module.exports = __webpack_public_path__ + "static/media/background_login.c0e43af9.jpg";